<template>
  <main-logo-register />
  <div class="mfa-wrapper" v-if="!configMfaComplete">
    <a-steps progress-dot :current="current" :items="steps" class="mfa-steps" />

    <div class="mfa-content">
      <keep-alive>
        <component
          :is="view"
          ref="step"
          :emailForm="emailForm"
          @next="nextStep"
          @back="prevStep"
          @setEmail="emailForm = $event"
        />
      </keep-alive>
      <!-- <StepDownloadApp v-if="current === 0" @next="nextStep" />
      <StepScanQr v-if="current === 1" @next="nextStep" @back="prevStep" />
      <StepValidateCode v-if="current === 2" @back="prevStep" /> -->
    </div>
  </div>
  <div class="mfa-wrapper" v-else style="padding-top: 70px">
    <StepValidateCode hide-back />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, provide, ref } from 'vue'
import httpManager from "@/app/shared/utils/httpManager";
import StepDownloadApp from '../mfa/StepDownloadApp.vue'
import StepScanQr from '../mfa/StepScanQr.vue'
import StepValidateCode from '../mfa/StepValidateCode.vue'
import MainLogoRegister from "@/app/shared/components/molecules/MainLogoRegister.vue";
import { MfaType } from '../../utils/enums';
import { router } from '@/router';
import StepValidateEmail from '../mfa/StepValidateEmail.vue';

const current = ref(0)
const nextStep = () => current.value++
const prevStep = () => current.value--

const typeMfa = ref(null as MfaType | null);
provide('typeMfa', typeMfa);

const emailForm = ref(null);
const configMfaComplete = ref(false);

const steps = computed(() => {
  if (typeMfa.value == MfaType.Google) {
    return [
      { title: "Descargar aplicación" },
      { title: "Escanear QR" },
      { title: "Validar código" },
    ];
  } else if (typeMfa.value == MfaType.Email) {
    return [
      { title: "Validar correo" },
      { title: "Validar código" },
    ];
  }
});

const view = computed(() => {
  if (typeMfa.value == MfaType.Google) {
    switch (current.value) {
      case 0:
        return StepDownloadApp;
      case 1:
        return StepScanQr;
      case 2:
        return StepValidateCode;
      default:
        return StepValidateCode;
    }
  } else if (typeMfa.value == MfaType.Email) {
    switch (current.value) {
      case 0:
        return StepValidateEmail;
      case 1:
        return StepValidateCode;
      default:
        return StepValidateCode;
    }
  }
});

onMounted(() => {
  console.log("MFA Template mounted", sessionStorage.getItem("redirect_login"));
  console.log("MFA Template mounted", sessionStorage.getItem("redirect_login") == 'true');
  if (sessionStorage.getItem("redirect_login") == 'true' || !sessionStorage.getItem("mfaData")) {
    sessionStorage.removeItem("redirect_login");
    sessionStorage.removeItem("authenticationData");
    sessionStorage.removeItem("mfaData");
    router.push('/login');
  } else {
    sessionStorage.setItem("redirect_login", 'true'); // set redirect to login flag when recharge page
    console.log("MFA Template mounted", sessionStorage.getItem("mfaData"));
    const mfaData = JSON.parse(sessionStorage.getItem("mfaData") || '{}');
    if (mfaData) {
      configMfaComplete.value = mfaData.mfa_first_time == "False" || false;
      typeMfa.value = mfaData.mfa_type || null;
    }
    let workspace = localStorage.getItem("workspace");
    httpManager.updateBaseURL(`https://${workspace}.backend.${import.meta.env.VITE_HOSTNAME}`);
  }
  
});
</script>

<style scoped lang="sass">
.mfa-wrapper
  background-color: #fff
  width: calc(100% - 40px)
  height: calc(100vh - 100px)
  margin: 0 auto
  padding: 2rem
  margin-top: 10px
  border-radius: 10px
  border: 1px solid #0000000F
  display: flow
  justify-items: center

  .mfa-steps
    max-width: 500px

  .mfa-content
    max-width: 480px
    margin-top: 32px
    display: grid
    gap: 32px

:deep(.mfa-steps .ant-steps-item-content)
  width: 150px !important
  position: relative !important
  left: -3px !important
  justify-content: center
  display: flex
</style>
